import React from 'react'

import { SmallText } from '../presentation/Text'
import Panel from '../structure/Panel'
import Tooltip from '../presentation/Tooltip'
import { useContrastColor } from '../theme/_hooks/colors'

const Event = ({ label, description, time, color, bgColor, onClick, ...props }) => {
  const serviceOrderName = description?.split('\n')[1]
  const title = serviceOrderName ? `${serviceOrderName} - ${label}` : label

  let tooltipDesc = label + '\n---\n' + description
  if (!time) tooltipDesc = false

  const handleClick = e => {
    e.stopPropagation()
    if (onClick) onClick()
  }
  return (
    <Tooltip position="topLeft" label={tooltipDesc} bgColor="menu" align="left">
      <Panel
        bgColor={bgColor || 'light1'}
        borderLeftColor={color || 'blue'}
        borderLeftWidth={0.5}
        paddingV={0.15}
        paddingH={0.4}
        radius={0.3}
        overflow="hidden"
        onClick={handleClick}
        {...props}
      >
        <SmallText size="xxsmall" bold noWrap color={useContrastColor(bgColor || 'light1')}>
          {title}
        </SmallText>
      </Panel>
    </Tooltip>
  )
}

export default Event
